<template>
    <v-tooltip right z-index="40">
        <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
                <slot></slot>
            </div>
        </template>
        <div class="stockScoreDetailsTip">
            <div class="tipTitle">{{ $t('subScore.scoreCalculationDetails') }}</div>
            <StockScoreDetail v-for="(ssd, i) in scoreDetails" :key="i" :scoreDetail="ssd" />
            <StockScoreDetailsTotal :score="scoreTotal" />
        </div>
    </v-tooltip>
</template>

<script>
import ScoreDetailsInfo from '../../../models/ScoreDetailsInfo';
import StockScoreDetail from './StockScoreDetail.vue';
import StockScoreDetailsTotal from './StockScoreDetailsTotal.vue';

export default {
    components: {
        StockScoreDetail,
        StockScoreDetailsTotal
    },
    props: {
        scoreDetailsInfo: {
            type: ScoreDetailsInfo,
            required: true
        }
    },
    computed: {
        scoreTotal() {
            return this.scoreDetailsInfo ? this.scoreDetailsInfo.score : null;
        },
        scoreDetails() {
            return this.scoreDetailsInfo ? this.scoreDetailsInfo.subScoreDetails : [];
        }
    }
}
</script>

<style lang="scss" scoped>
.v-tooltip__content.menuable__content__active {
    opacity: 1;
    background-color: #FFF;
    border: solid 1px #333;
    padding: 10px;
}
.stockScoreDetailsTip {
    width: 300px;
    color: #333;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .tipTitle {
        font-weight: bold;
        color: var(--v-agora-base);
    }
}
</style>